import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { useLang } from "../lib/i18n";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export function PaymentSuccess() {
  const { t } = useLang();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");
  const [orderId, setOrderId] = useState(null);

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setOrderId(data.order_id);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { setState("failed"); return; }
      if (tries++ < 8) setTimeout(poll, 1800); else setState("failed");
    };
    if (sid) poll(); else setState("failed");
  }, [sid]);

  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
      {state === "checking" && <><Loader2 className="h-12 w-12 animate-spin text-blue-600" /><p className="font-semibold text-slate-600">{t("loading")}</p></>}
      {state === "paid" && <>
        <CheckCircle2 className="h-16 w-16 text-emerald-600" />
        <h1 className="font-display text-2xl font-extrabold text-slate-900">{t("payment_ok")}</h1>
        <button data-testid="payment-view-order" onClick={() => nav(orderId ? `/ordine/${orderId}` : "/area-clienti/ordini")} className="mt-2 rounded-xl bg-blue-600 px-6 py-3 font-bold text-white">{t("receipt")}</button>
        {orderId && <button data-testid="payment-leave-review" onClick={() => nav(`/ordine/${orderId}`)} className="rounded-xl border border-amber-300 bg-amber-50 px-6 py-3 font-bold text-amber-700">{t("leave_review")}</button>}
      </>}
      {state === "failed" && <>
        <XCircle className="h-16 w-16 text-rose-500" />
        <h1 className="font-display text-2xl font-extrabold text-slate-900">{t("payment_cancel")}</h1>
        <button onClick={() => nav("/area-clienti/ordini")} className="mt-2 rounded-xl border border-slate-200 bg-white px-6 py-3 font-bold text-slate-700">{t("my_orders")}</button>
      </>}
    </div>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <div className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
      <XCircle className="h-16 w-16 text-rose-500" />
      <h1 className="font-display text-2xl font-extrabold text-slate-900">{t("payment_cancel")}</h1>
      <button onClick={() => nav("/area-clienti/ordini")} className="mt-2 rounded-xl bg-blue-600 px-6 py-3 font-bold text-white">{t("my_orders")}</button>
    </div>
  );
}
